import { render } from "./MobileDefault.vue?vue&type=template&id=b4807e90&scoped=true"
import script from "./MobileDefault.vue?vue&type=script&lang=js"
export * from "./MobileDefault.vue?vue&type=script&lang=js"

import "./MobileDefault.vue?vue&type=style&index=0&id=b4807e90&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4807e90"]])

export default __exports__